import { FC } from 'react';

import { DrawerProps } from 'antd/es/drawer';

import { StyledDrawer } from '@components/views/components/listing/ResponsiveListingSearchStyle';
import CustomIcon from '@components/utils/CustomIcon';
import { CloseIcon } from '@assets/icons';

const ResponsiveDrawer: FC<DrawerProps> = ({
  open,
  onClose,
  title = '',
  children,
  ...otherProps
}) => {
  return (
    <StyledDrawer
      title={title}
      closeIcon={
        <CustomIcon
          icon={CloseIcon}
          fontSize={24}
          paletteColor='whiteAlpha600'
        />
      }
      placement='top'
      onClose={onClose}
      open={open}
      destroyOnHidden={true}
      styles={{
        wrapper: {
          height: '100%',
        },
      }}
      {...otherProps}
    >
      {children}
    </StyledDrawer>
  );
};

export default ResponsiveDrawer;
